export default "__VITE_ASSET__C2bZjunU__"